import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ChatView from "./components/Main/ChatView";
import { FirebaseProvider } from "./contexts/firebase/firebaseContext";
import { RequestProvider } from "./contexts/requestContext";

const App = () => {
  return (
    <RequestProvider>
      <FirebaseProvider>
        <ChatView />
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={true}
        />
      </FirebaseProvider>
    </RequestProvider>
  );
};

export default App;
